module.exports = __webpack_public_path__ + "static/media/Resource2.0aae83d5.webp";